@if (isLoading()) {
  <lib-skeleton variant="fields" [count]="8" [columns]="5" />
} @else if (deal()) {
  <!-- Lot number + status badge -->
  <div class="flex items-center gap-4 mb-4">
    <span class="font-medium text-body-lg-500 text-primary-500 font-title">{{ deal()?.lot?.lotNo || '—' }}</span>
    @if (deal()?.dealStatus?.name) {
      <p-badge [value]="deal()!.dealStatus!.name" severity="success" badgeSize="small" class="uppercase rounded-full" />
    }
  </div>

  <h3 class="text-body-500 text-slate-700 mb-3">Lot Details</h3>

  <!-- 5-column data row -->
  <div class="grid grid-cols-2 sm:!grid-cols-3 lg:!grid-cols-5 gap-x-4 gap-y-5">
    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Project</span>
      <span class="text-body-500 text-slate-700">{{ deal()?.project?.projectCode || '—' }}</span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Lot</span>
      <span class="text-body-500 text-slate-700">{{ deal()?.lot?.lotNo || '—' }}</span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Model(Elevation)</span>
      <span class="text-body-500 text-slate-700">
        @if (deal()?.model?.modelName && deal()?.elevation?.elevationCode) {
          {{ deal()!.model!.modelName }}({{ deal()!.elevation!.elevationCode }})
        } @else {
          {{ deal()?.model?.modelName || '—' }}
        }
      </span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Sales Agent</span>
      <span class="text-body-500 text-slate-700">
        @if (deal()?.salesAgents?.length) {
          @for (agent of deal()!.salesAgents; track agent.id; let last = $last) {
            {{ agent.name }}
            @if (!last) {
              ,
            }
          }
        } @else {
          —
        }
      </span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Sales Floor Agent</span>
      <span class="text-body-500 text-slate-700">
        @if (deal()?.salesFloorAgent?.firstName) {
          {{ deal()!.salesFloorAgent!.firstName }} {{ deal()!.salesFloorAgent!.lastName }}
        } @else {
          —
        }
      </span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">CFL Status</span>
      <span class="text-body-500 text-slate-700">{{ deal()?.isCFL ? 'True' : 'False' }}</span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Swing</span>
      <span class="text-body-500 text-slate-700">{{ deal()?.lot?.swing || '—' }}</span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Closing Date</span>
      <span class="text-body-500 text-slate-700">{{ (closingDate() | date: 'MM/dd/yyyy') || '—' }}</span>
    </div>
  </div>
} @else {
  <p class="text-body-sm text-slate-400 text-center py-6">Deal information not available.</p>
}
